import { Controller } from "@hotwired/stimulus"

const FRONT_ELEMENT_ID = "front-chat-iframe"

export default class extends Controller {
  static values = { id: String }

  declare idValue: string

  disconnect() {
    frontPromise = null
  }

  async load() {
    const chatId: string = this.idValue

    await loadFront(chatId)
    FrontChat("init", { chatId, useDefaultLauncher: false, onInitCompleted: () => onInitCompleted() })
  }
}

declare let FrontChat: any

let frontPromise: Promise<void>

function loadFront(chatId: string): Promise<void> {
  return (frontPromise ||= loadFrontScript(chatId))
}

let script: HTMLScriptElement

function loadFrontScript(chatId: string): Promise<void> {
  return new Promise((resolve) => {
    script?.remove()
    script = document.createElement("script")
    script.onload = () => resolve()
    script.defer = true
    script.src = "https://chat-assets.frontapp.com/v1/chat.bundle.js"
    script.dataset.chatId = chatId
    document.head.appendChild(script)
  })
}

function makeIframeAccessible() {
  const iframe = document.getElementById(FRONT_ELEMENT_ID)
  if (iframe) {
    iframe.setAttribute("aria-label", "Live chat")
  }
}

function onInitCompleted() {
  FrontChat("show")
  makeIframeAccessible()
  watchChatState()
}

function watchChatState() {
  const iframe = document.getElementById(FRONT_ELEMENT_ID) as HTMLElement
  if (!iframe) return

  const observer = new MutationObserver(() => {
    const isOpen = iframe.style.width !== "0px" && iframe.style.height !== "0px"
    iframe.classList.toggle("front-chat-open", isOpen)
  })

  observer.observe(iframe, { attributes: true, attributeFilter: ["style"] })
}
